// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DWDModal_modal-content__dbOdS {
  border-radius: unset;
  border: 1px solid lightgray;
  box-shadow: 2px 2px 10px lightgray;
}

.DWDModal_orangeBorder__QGAg4 {
  display: flex !important;
  align-items: center;

  .DWDModal_modal-content__dbOdS {
    padding: 5px;
  }
}

.DWDModal_greenBorder__KMdfH {
  display: flex !important;
  align-items: center;

  .DWDModal_modal-content__dbOdS {
    padding: 5px;
    border: 1px solid lightgray;
  }
}

.DWDModal_modal-header__vrywL {
  border-bottom: unset;
  padding: 10px 10px 0px 10px;
}

.DWDModal_modal-title__wCkfl {
  margin-bottom: 0;
  line-height: 1;
}

.DWDModal_modal-body__L0QnY {
  padding: 0px 10px 0px 10px;

}

.DWDModal_modal-footer__Rg81e {
  border-top: unset;
  display: unset;
  padding: 0px 10px 10px 10px;
}

.DWDModal_btn-close__OrF3- {
  margin-bottom: 5% !important;
}

.DWDModal_cycleTitle__F66H9 {
  border: unset !important;
}

.DWDModal_customTextArea__1BFxK {
  min-width: 285px;
}

.DWDModal_bckSummary__DsZPE {
  position: fixed;
  top: 20px;
  z-index: 1500;
  width: max-content;
  padding: 0px;
  background: rgb(25, 118, 210);
  color: white;
  border-width: medium;
  border-style: none;
  border-color: currentcolor;
  border-image: initial;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px; 
}

.DWDModal_bckSummary__DsZPE img {
  width: 25px;
  vertical-align: bottom !important;
}


@media screen and (min-width: 350px) and (max-width: 500px) {
  .DWDModal_feedbackContainer__XdAX6{
    width: 90%!important;
  }
  .DWDModal_dataTreeContainer__s1w0s{
    width: 90% !important;
    height: auto;
    padding: 0px 32px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/Components/DWDModal/DWDModal.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;;EAEnB;IACE,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;;EAEnB;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;;AAGA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,4BAA4B;EAC9B;AACF","sourcesContent":[".modal-content {\n  border-radius: unset;\n  border: 1px solid lightgray;\n  box-shadow: 2px 2px 10px lightgray;\n}\n\n.orangeBorder {\n  display: flex !important;\n  align-items: center;\n\n  .modal-content {\n    padding: 5px;\n  }\n}\n\n.greenBorder {\n  display: flex !important;\n  align-items: center;\n\n  .modal-content {\n    padding: 5px;\n    border: 1px solid lightgray;\n  }\n}\n\n.modal-header {\n  border-bottom: unset;\n  padding: 10px 10px 0px 10px;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1;\n}\n\n.modal-body {\n  padding: 0px 10px 0px 10px;\n\n}\n\n.modal-footer {\n  border-top: unset;\n  display: unset;\n  padding: 0px 10px 10px 10px;\n}\n\n.btn-close {\n  margin-bottom: 5% !important;\n}\n\n.cycleTitle {\n  border: unset !important;\n}\n\n.customTextArea {\n  min-width: 285px;\n}\n\n.bckSummary {\n  position: fixed;\n  top: 20px;\n  z-index: 1500;\n  width: max-content;\n  padding: 0px;\n  background: rgb(25, 118, 210);\n  color: white;\n  border-width: medium;\n  border-style: none;\n  border-color: currentcolor;\n  border-image: initial;\n  border-radius: 4px;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px; \n}\n\n.bckSummary img {\n  width: 25px;\n  vertical-align: bottom !important;\n}\n\n\n@media screen and (min-width: 350px) and (max-width: 500px) {\n  .feedbackContainer{\n    width: 90%!important;\n  }\n  .dataTreeContainer{\n    width: 90% !important;\n    height: auto;\n    padding: 0px 32px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `DWDModal_modal-content__dbOdS`,
	"orangeBorder": `DWDModal_orangeBorder__QGAg4`,
	"greenBorder": `DWDModal_greenBorder__KMdfH`,
	"modal-header": `DWDModal_modal-header__vrywL`,
	"modal-title": `DWDModal_modal-title__wCkfl`,
	"modal-body": `DWDModal_modal-body__L0QnY`,
	"modal-footer": `DWDModal_modal-footer__Rg81e`,
	"btn-close": `DWDModal_btn-close__OrF3-`,
	"cycleTitle": `DWDModal_cycleTitle__F66H9`,
	"customTextArea": `DWDModal_customTextArea__1BFxK`,
	"bckSummary": `DWDModal_bckSummary__DsZPE`,
	"feedbackContainer": `DWDModal_feedbackContainer__XdAX6`,
	"dataTreeContainer": `DWDModal_dataTreeContainer__s1w0s`
};
export default ___CSS_LOADER_EXPORT___;
